import { AppConstants } from 'src/app/app.constants';
import { Component, Inject, forwardRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { MainComponent } from './main.component';
import { FormGroup } from '@angular/forms';

import { Subject } from 'rxjs';
import { Appointment, Customer, InvoiceDetailType, ItemCode, ProcessStatus } from 'src/app/api/models/web-booking.models';

@Component({ template: '' })

export class BaseComponent {

  public baseTriggerChild = new Subject();
  idleTimeInHour = 15;

  constructor(
    @Inject(forwardRef(() => MainComponent)) public app: MainComponent,
    public cdRef: ChangeDetectorRef) {
    this.app.loadingDescription = 'Loading...';    
    this.app.hasGiftVoucherItem = false;
    this.app.hasBookingItem = true;
  }

  // Screen
  public timer: any;

  // Start the idle timer when user stop navigating the website
  // Display alert button when user idle for 15 minutes
  // Then reload page when user clicks the alert button
  @HostListener('mouseout') onMouseOut(): void {
    // if (this.app == null || this.app.config == null || this.app.config.idleTimeOut === 0) { return; }
    // let counter = 0;
    // this.timer = setInterval(() => {
    //   counter++;
    //   if (counter === (this.app.config.idleTimeOut * 60)) {
    //     // Alert window
    //     alert('You been idle for more than 15 minutes, your season has been timeout.');

    //     // Add function to call and navigate back to a designated url
    //     window.location.reload();

    //     this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
    //     this.app.storageService.removeItem(AppConstants.BookingSelectedDate);
    //     this.app.storageService.removeItem(AppConstants.BookingSelectedTime);
    //     this.app.storageService.removeItem(AppConstants.BookingSelectedSlot);
    //     this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);

    //     this.app.router.navigate([AppConstants.RouteSelectConsultation]);

    //     // Clear Timer
    //     clearInterval(this.timer);
    //   }
    // }, 1000);
  }

  // Stop the timer once the user navigate back to the website
  @HostListener('mouseover') onMouseOver(): void {
    // if (this.app == null || this.app.config == null || this.app.config.idleTimeOut === 0) { return; }
    // clearInterval(this.timer);
  }

  start(): void {    
    const cartItems = this.app.storageService.getItem(AppConstants.GiftVoucherSelectedVouchers);
    if (this.app.stringService.isNotEmpty(cartItems)) {
      this.app.basketItems = JSON.parse(cartItems);
    }
    if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.Customer))) {
      this.app.customer = JSON.parse(this.app.storageService.getItem(AppConstants.Customer)) as Customer;
    }

    if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.Token))) {
      this.app.token = this.app.storageService.getItem(AppConstants.Token);
      this.app.spinner.show();
      this.app.webBookingService.ValidateUserToken()
        .subscribe(
          data => {
            this.getLocations();
          },
          error => {
            this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
            this.app.storageService.removeItem(AppConstants.PendingTransaction);
            this.app.storageService.removeItem(AppConstants.Token);
            this.app.storageService.removeItem(AppConstants.Customer);
            this.showErrorMessage('Session time out, please login to continue');
            this.app.spinner.hide();
            this.app.router.navigate([AppConstants.RouteLogin]);
          });
    }
    else {
      this.getLocations();
    }
  }

  getLocations(): void {
    this.app.spinner.show();
    this.app.webBookingService.GetLocations()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.branch = data[0];
          this.app.storageService.setItem(AppConstants.DefaultBranch, JSON.stringify(this.app.branch));
          this.checkCustomerData();
          this.baseTriggerChild.next('go');
        },
        error => {
          this.app.storageService.setItem(AppConstants.BookingProcessStatus, ProcessStatus.SelectTreatment.toString());
          this.app.spinner.hide();
          this.app.router.navigate([AppConstants.RouteLogin]);
          this.showErrorMessage(error);
        }
      );
  }

  showErrorMessage(data: any): void {
    const message = this.getBadRequest(data);
    this.app.toastr.error(message, 'Error', { timeOut: 3000 });
  }

  showInfoMessage(message: string): void {
    this.app.toastr.info(message, 'Info', { timeOut: 3000 });
  }

  showSuccessMessage(message: string): void {
    this.app.toastr.success(message, 'Success', { timeOut: 3000 });
  }

  checkCustomerData(): void {
    if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.Customer))) {
      this.app.customer = JSON.parse(this.app.storageService.getItem(AppConstants.Customer)) as Customer;

      const currentDate = new Date();

      if (this.app.customer != null) {

        if (this.app.stringService.isNotEmpty(this.app.customer.dateJoined)) {

          const dateJoined = this.app.dateService.getNewDate(this.app.customer.dateJoined);

          if (dateJoined.toDateString() === currentDate.toDateString() &&
            this.app.customer.hasPaidAppointment !== true) {
            this.app.customer.isNewCustomer = true;
          } else if (this.app.customer.hasPaidAppointment !== true) {
            this.app.customer.isNewCustomer = true;
          }
          else {
            this.app.customer.isNewCustomer = false;
          }
        }


        if (this.app.stringService.isNotEmpty(this.app.customer.lastTransactionDate)) {
          const lastTrasactionDate = this.app.dateService.getNewDate(this.app.customer.lastTransactionDate);
          if (this.getYearDifference(currentDate, lastTrasactionDate) >= 2) {
            this.app.customer.is2YearLastTransaction = true;
          }
          else{
            this.app.customer.is2YearLastTransaction = false;
          }
        }
        else {
          this.app.customer.is2YearLastTransaction = true;
        }
      }
      this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
    }
  }

  getYearDifference(d1: any, d2: any) {
    let timeDiff = d1 - d2.getTime();
    let age = (timeDiff / (1000 * 3600 * 24)) / 365.25;
    return age;
 }

  redirectToNextPage(): void {
    // Clear Current Service in Process
    if (this.app.stringService.isNotEmpty(this.app.storageService.getItem(AppConstants.Appointment))) {
      const appointment = JSON.parse(this.app.storageService.getItem(AppConstants.Appointment)) as Array<Appointment>;
      if (appointment != null && appointment.length > 0)
      {
        this.app.storageService.removeItem(AppConstants.Appointment);
        // this.cancelBaseAppointment(appointment[0].appointmentId);
      }
    }    

    // Clear Current Cart In Progress
    var strBasket = this.app.storageService.getItem(AppConstants.GiftVoucherSelectedVouchers);
    if (this.app.stringService.isNotEmpty(strBasket)) {
      var basket = JSON.parse(strBasket);
      console.log(basket);
      if (basket != null && basket.length > 0) {
        basket.forEach((e: { invoiceDetailType: InvoiceDetailType; appointmentId: any; }) => {
          if (e.invoiceDetailType == InvoiceDetailType.Service) {
            // this.cancelBaseAppointment(e.appointmentId);
          }
        });
      }
      this.app.storageService.removeItem(AppConstants.GiftVoucherSelectedVouchers);
      this.app.reCompute();
    }

    // Redirect if to select treatment if no redirect state    
    const redirectState = this.app.storageService.getItem(AppConstants.RedirectState);
    this.app.storageService.removeItem(AppConstants.RedirectState);
    if (this.app.stringService.isEmpty(redirectState) || redirectState === AppConstants.RouteLogin) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }

    // Get Data
    if (this.app.stringService.isEmpty(this.app.storageService.getItem(AppConstants.BookingSelectedTreatment))) {
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    const service = JSON.parse(this.app.storageService.getItem(AppConstants.BookingSelectedTreatment)) as ItemCode;

    const isNextPageConfirmationPage = redirectState.includes(AppConstants.RouteServiceConfirmation);
    if (isNextPageConfirmationPage === false) {
      this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
      this.app.router.navigate([redirectState]);
      return;
    }

    

    if (!service.newClientTreatment && (this.app.customer.isNewCustomer || this.app.customer.is2YearLastTransaction)) {
      this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }
    if (service.newClientTreatment && (!this.app.customer.isNewCustomer || !this.app.customer.is2YearLastTransaction)) {
      this.app.storageService.removeItem(AppConstants.BookingSelectedTreatment);
      this.app.router.navigate([AppConstants.RouteSelectConsultation]);
      return;
    }

    this.app.router.navigate([redirectState]);
  }

  cancelBaseAppointment(appointmentId: string): void {
    const m = { appointmentId };
    this.app.webBookingService.CancelAppointment(m)
      .subscribe(data => { }, error => { });
  }

  getBadRequest(data: any): string {
    let message = '';
    if (data != null && data._body != null) {
      const body = JSON.parse(data._body);
      if (body.message != null) { message = body.message; }
      if (body.error_description != null) { message = body.error_description; }
    }
    else if (data.error != null && data.error !== undefined) {
      if (data.error.message != null) { message = data.error.message; }
      if (data.error.error_description != null) { message = data.error.error_description; }
    }
    else {
      message = data;
    }
    return message;
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    if (formGroup === null || formGroup === undefined) { return; }
    for (const i in formGroup.controls) {
      formGroup.controls[i].markAsTouched();
    }
  }

  scrollTo(): void {
    location.hash = '#top';
  }
}
